import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserUniformDesignGameProps {
    onComplete: () => void;
}

interface PhaserUniformDesignGameState {
}

const gameConfig: GameConfig = {
    title: "Uniform Design Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserUniformDesignGame extends React.Component<PhaserUniformDesignGameProps, PhaserUniformDesignGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserUniformDesignGameProps) {
        super(props);
        bindAllOfThis(this, PhaserUniformDesignGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserUniformDesignGame;



// WEBPACK FOOTER //
// ./src/games/UniformDesignGame/main.tsx